import { Info, Plus } from 'lucide-react';

import { PageHeader } from '@/shared/components/page-header';
import { Button } from '@/shared/components/shadcn/button';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';

export function CampaignsPageHeader({
  activeOrScheduledCount,
  isCreateDisabled,
  planCampaignLimit,
  onCreateCampaign,
}: {
  activeOrScheduledCount: number;
  isCreateDisabled: boolean;
  planCampaignLimit: number;
  onCreateCampaign: () => void;
}) {
  return (
    <PageHeader
      title="Campaigns"
      description="Manage scheduled, active, and ended influencer campaigns in one workspace."
      actions={
        <>
          {planCampaignLimit > 0 ? (
            <div className="hidden items-center gap-2 lg:flex">
              <p className="text-foreground text-sm font-semibold">
                {activeOrScheduledCount} / {planCampaignLimit} Campaigns
              </p>
              <TooltipFlat
                asChild
                content="Active and scheduled campaigns count toward your current plan."
              >
                <button
                  type="button"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                  aria-label="Campaign plan usage info"
                >
                  <Info className="size-4" />
                </button>
              </TooltipFlat>
            </div>
          ) : null}
          <Button onClick={onCreateCampaign} disabled={isCreateDisabled}>
            <Plus className="size-4" />
            Create campaign
          </Button>
        </>
      }
    />
  );
}
